module.exports = __webpack_public_path__ + "static/media/stbLogoDark.1ec61976.svg";